import { render, staticRenderFns } from "./AIAssistantMessage.vue?vue&type=template&id=758c41b6&scoped=true"
import script from "./AIAssistantMessage.vue?vue&type=script&lang=js"
export * from "./AIAssistantMessage.vue?vue&type=script&lang=js"
import style0 from "./AIAssistantMessage.vue?vue&type=style&index=0&id=758c41b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758c41b6",
  null
  
)

export default component.exports